const bg = {
  "Home": "Начало",
  "Add": "Добави",
  "Edit": "Редакция",
  "Adding": "Добавяне на",
  "Editing": "Редактиране на",
  "Delete": "Изтрий",
  "Save": "Запази",
  "Cancel": "Откажи",
  "Close": "Затвори",
  "Open": "Отвори",
  'View': 'Преглед',
  'Remove': 'Премахни',
  'Medicines': 'Лекарства',
  'Medicine': 'Лекарство',
  'OverviewAbout': 'Какво представлява и за какво се използва',
  'OverviewBeforeIntake': 'Какво трябва да знаете преди да използвате',
  'OverviewDosage': 'Как да използвате',
  'OverviewSideEffects': 'Възможни нежелани реакции',
  'OverviewSafetyData': ' Как да съхранявате',
  'OverviewAdditionalInfo': 'Съдържание на опаковката и допълнителна информация',
  'LeafletUserInfo': 'Листовка: информация за потребителя',
  'WhatIsInLeaflet': 'Какво съдържа тази листовка:',
  'WhatIsInProduct': 'Какво съдържа',
  'ActiveIngredients': 'Активни съставки',
  'WhatLooksAndPackageContents': 'Как изглежда и какво съдържа опаковка',
  'FirstSideImprint': 'означени от едната страна с',
  'NotAllPackagesMarketed': 'Не всички видове опаковки могат да бъдат пуснати в продажба.',
  'MarketingAuthorisationHolderAndManufacturer': 'Притежател на разрешението за употреба и производител',
  'MarketingAuthorisationHolder': 'Притежател на разрешението за употреба',
  'Manufacturer': 'Производител',
  'BrandName': 'Търговско име',
  'GenericName': 'Генерично име',
  'Overview': 'Описание',
  'SideEffects': 'Странични ефекти',
  'Dosage': 'Дозировка',
  'Professional': 'За специалисти',
  'Interactions': 'Взаимодействия',
  'Interactions with': 'Взаимодействия с',
  'interactions': 'взаимодействия',
  'Leaflet': 'Листовка',
  'InactiveIngredients': 'Неактивни съставки',
  'LeafletForUser': 'Листовка за пациента',
  'SmPC': 'Кратка характеристика на продукта',
  'Leaflets': 'Листовки',
  'FilesForDownload': 'Файлове за сваляне',
  'PharmaceuticalForm': 'Фармацевтична форма',
  'Imprint': 'Oтпечатък',
  'Strength': 'Сила',
  'Color': 'Цвят',
  'Size': 'Размер',
  'Shape': 'Форма',
  'Packiging': 'Опаковка',
  'PackegeSize': 'Брой в опаковка',
  'DDD': 'Дневна доза',
  'RouteOfAdministration': 'Начина на приемане',
  'ProductInformation': 'Информация за продукта',
  'ProductType': 'Тип на продукта',
  'ItemCode': 'Код',
  'Name': 'Име',
  'BasisOfStrength': 'Основа на силата',
  'ProductCharacteristics': 'Характеристика на продукта',
  'MarketingInformation': 'Маркетингова информация',
  'FirstAuthorizationDate': 'Дата на първо одобрение',
  'LastAuthorizationDate': 'Дата на последно одобрение',
  'Score': 'Разделяне',
  'Flavor': 'Вкус',
  'Contains': 'Съдържа',
  'MedicineIndexAtoZ': 'Лекарства от А до Я',
  'MedicineBrowseText': 'Различните начини на търсене по-долу ще ви помогнат за по-лесното откриване на информация за търсения лекарствен продукт. Наличната информация за над 24 000 лекарства отпускани със и без рецепта, е както за потребители, така и за здравни специалисти.',
  'BrowseAllMedicine': 'Списък с всички лекарства',
  'CheckMedicineInteractions': 'Взаимодействия между лекарства',
  'SearchMedicineInDatabase': 'Търсене по име на лекарство или активна съставка',
  'BrowseAlphabetically': 'Азбучен указател',
  'BrowseMedicinesByCategory': 'Лекарства по категории',
  'Top40MedicineSearches': '10 най-търсени лекарства',
  'Pregnancy': 'Бременност',
  'Breastfeeding': 'Кърмене',
  'Pregnancy&Breastfeeding': 'Бременност и кърмене',
  'EnterMedicineName': 'Лекарство или активна съставка',
  'MedicineListDescription': 'Списък на лекарства и медикаменти по търговско или генерично име.',
  'MedicineListDescriptionStartWith': 'Списък на лекарства и медикаменти по търговско или генерично име започващи с буквата',
  'MedicineListDescriptionBySearchText': 'Списък на лекарства и медикаменти по търговско или генерично име съдържащи търсения текст',
  'MedXchangeDescription': 'MedXchange е помощник в процеса на лечение, който предоставя подробна информация за съдържанието и взаимодействието на веществата в лекарствените продукти с други лекарства, храни и заболявания.',
  'CanNotFindYourMedicine': 'Не си открил твоето лекарство?',
  'ResulFound': 'намерени резултата.',
  'Major': 'Силни',
  'Moderate': 'Умерени',
  'Minor': 'Маловажни',
  'Unknown': 'Неизвестни',
  'DrugInteractionClassification': 'Класификация на взаимодействието с лекарствата',
  'DrugInteractionClassificationDescription': 'Класификациите по-долу са само общи насоки. Трудно е да се определи значението на дадено лекарствено взаимодействие за всяко лице, имайки предвид големия брой фактори.',
  'DrugInteractionClassificationMajor': 'Изключително клинична значимост. Избягвайте комбинации; рискът от взаимодействие надхвърля ползата.',
  'DrugInteractionClassificationModerate': 'Умерена клинична значимост. Добре е да избягвате комбинации. Използвайте го само при специални обстоятелства.',
  'DrugInteractionClassificationMinor': 'Минимална клинична значимост. Минимизиране на риска, да се прецени и помилси за алтернативенo лекарство, да се предприемат стъпки за заобикаляне на риска от взаимодействие и/или да се създаде план за наблюдение.',
  'DrugInteractionClassificationUnknown': 'Няма налична информация.',
  'DrugInteractionClassificationDoNotStop': 'Не приемайте каквито и да е лекарства преди да се консултирате с вашия лекар.',
  'DrugInteractions': 'Взаимодействия с лекарства',
  'Alcohol/FoodInteractions': 'Взаимодействия с алкохол и храни',
  'DriveMachineInteractions': "Взаимодействия при шофиране и машини",
  'drive/machineInteractions': "взаимодействия при шофиране и машини",
  'DiseaseInteractions': 'Взаимодействия със заболявания',
  'A total of %s drugs (%s brand and generic names) are known to interact with ': 'Общо %s лекарства (%s търговски и генерични имена) взаимодействат с ',
  'drug interactions': 'взаимодействия с лекарства',
  'brand and generic names': 'търговски и генерични имена',
  'Show all medications in the database that may interact with': 'Всички лекарства, които могат да взаимодействат с',
  'with': 'c',
  'Alcohol and food interactions with': 'Алкохол и храни, които взаимодействат с',
  'Disease interactions with': 'Заболявания, които имат взаимодействие с',
  'There are': 'Има',
  'Drug interactions between %s and %s': 'Взаимодействия между %s и %s',
  'Switch to professional interaction data': 'Информация за специалисти',
  'Switch to consumer interaction data': 'Информация за потребители',
  'Consumer': 'За потребители',
  'Drug interactions with': 'Лекарства, които имат взаимодействие с',
  'Summary': 'Резюме',
  'For the Consumer': 'За потребители',
  'Overdose Description': 'Предозиране',
  'For Healthcare Professionals': 'За медицински специалисти',
  'Other Information': 'Друга информация',
  'Other Comments': 'Други коментари',
  'Precautions': 'Предпазни мерки',
  'Dose Adjustments': 'Дозировка',
  'Very Common': 'Много често',
  'Common': 'Често',
  'Uncommon': 'Нечесто',
  'Rare': 'Рядко',
  'Very rare': 'Много рядко',
  'Frequency not reported': 'Не е отчетена',
  'Postmarketing reports': 'Отчетена след пускането на пазара',
  '10% or more': '10% и повече',
  '1% to 10%': 'от 1% до 10%',
  '0.1% to 1%': 'от 0.1% до 1%',
  '0.01% to 0.1%': 'от 0.01% до 0.1%',
  '0.001% to 0.01': 'от 0.001% до 0.01',
  'usual dose for': 'обичайна доза за',
  'Adult': 'Възрастни',
  'Pediatric': 'Деца',
  'Comments': 'Коментари',
  'Uses': 'Употреба',
  'Maximum dose': 'Максимална доза',
  'Duration of therapy': 'Пордължителност на терапията',
  'Implant': 'Имплантация',
  'Inhalation': 'Инхалация',
  'Instillation': 'Внушаване',
  'Nasal': 'Назално',
  'Oral': 'Устно',
  'Parenteral': 'Parenteral',
  'Rectal': 'Ректално',
  'Sublingual/buccal/oromucosal': 'Сублингвално/букално/устна лигавица',
  'Transdermal': 'Трансдермално',
  'Vaginal': 'Влагалищно',
  'Human drug': 'Лекарство за хора',
  'Login': 'Вход',
  'Email': 'Електронна поща',
  'Password': 'Парола',
  'New to MedXchange?': 'Нов потребител ли сте в MedXchange?',
  'or login with': 'или влезте с',
  'Forgot password?': 'Забравил си паролата?',
  'Create a New Account': 'Създаване на нов акаунт',
  'Confirm Password': 'Потвърди парола',
  'Create': 'Създай',
  'Please accept personal data private Policy': 'Моля потвърдете политиката за защита на личните данни.',
  'Accept': 'Потвърди',
  'personal data protection policy': 'политика за защита на личните данни',
  'Please enter your email.': 'Моля въведете вашия Email.',
  'Send': 'Изпрати',
  'Invalid E-mail or Password.': 'Невалидни "Електронна поща" или "Парола".',
  'Invalid E-mail.': 'Невалидна "Електронна поща".',
  '4000': 'Несъществуващ потребител.',
  '4001': 'Невалидна стара парола.',
  '4002': 'Новата и потвърдената пароли не са еднакви.',
  '4003': 'Вече има регистриран потребител с тази Електронна поща.',
  '4004': 'Невалидна Електорнна поща.',
  '4005': 'Невалиден линк или изтекал срок на валидност на линка.',
  '4006': 'Невалиднa Електорнна поща за този линк.',
  'Change': 'Смени',
  'Change Password': 'Смени парола',
  'Old Password': 'Стара парола',
  'New Password': 'Нова парола',
  'Please enter Old Password': 'Моля въведете старата парола',
  'Please enter New Password': 'Моля въведете новата парола',
  'Please enter Confirm Password': 'Моля въведете Потвърди парола',
  'New Password and Confirm Password are different': 'Новата и потвърдената пароли са различни',
  'Password and Confirm Password are different': 'Парола и Потвърди парола са различни',
  'Profile': 'Профил',
  'My Medicine': 'Моето лекарство',
  'My Medicines': 'Моите лекарства',
  'My Diseases': 'Моите заболявания',
  'Logout': 'Изход',
  'Please enter Password': 'Моля въведете Парола',
  'Please enter Email': 'Моля въведете Електронна поща',
  'Please enter valid Email': 'Моля въведете валидна Електронна поща',
  'Please enter Name': 'Моля въведете Име',
  'You have successfully changed your Password.': 'Вие успешно променихте паролата си.',
  'You have successfully saved your data.': 'Вие успешно записахте данните.',
  'You have successfully logged in.': 'Вие влязохте успешно.',
  'You have successfully created a new account.': 'Вие успешно създадохте нов акаунт.',
  'Now you can go to ': 'Сега можете да отидете на ',
  'Check your E-mail box to confirm registration and activate your account.': 'Проверете Електронната си поща, за да потвърдите регистрацията и активирате Вашият акаунт.',
  'You have successfully activated your account.': 'Вие успешно създадохте нов акаунт.',
  'Sorry but your activation link is not valid or expired.': 'Вашият линк за активация не е валиден или е с изтекал период.',
  'We have sent an E-mail to you.': 'Изпратихме Ви E-mail за потвърждение.',
  'Please check your E-mail box and click on confirmation link to change your password.': 'Моля проверете Вашият E-mail и натиснете на линка за потвърждение, за да смените паролата си.',
  'Enter new Password': 'Въведете новата парола',
  'Disease': 'Заболяване',
  'Disease Type': 'Тип заболяване',
  'Start Date': 'Начална дата',
  'End Date': 'Крайна дата',
  'Actions': 'Действия',
  'Select': 'Изберете',
  'Save & Close': 'Запис и Затваряне',
  'No Selection': 'Няма избор',
  'Disease code': 'Код на заболяването',
  'Disease name': 'Име на заболяването',
  'Filter': 'Филтър',
  'Clear': 'Изчисти',
  'InfectiousDisease': 'Инфекциозно заболяване',
  'DeficiencyDisease': 'Дефицитно заболяване',
  'HereditaryDisease': 'Наследствено заболяване',
  'PhysiologicalDisease': 'Физиологично заболяване',
  'ChronicDisease': 'Хронично заболяване',
  'Single Dose': 'Единична доза',
  'Frequency Of Intake': 'Честота на приемане',
  'Intake Conditions': 'Условия на приемане',
  'Alarms': 'Аларми',
  'Medicine Number': 'Номер на лекарство',
  'Number': 'Номер',
  'Additional Title': 'Допълнително описание',
  'Diseases': 'Заболявания',
  'Prescriptions': 'Рецепти',
  'My Prescriptions': 'Моите рецепти',
  'Profession': 'Професия',
  'Driver': 'Шофиране',
  'MachineOperator': 'Оператор на машина',
  'Prescription': 'Рецепта',
  'Doctor': 'Доктор',
  'Hospital': 'Лечебно заведение',
  'All Medicines': 'Всички лекарства',
  'All Diseases': 'Всички заболявания',
  'Selected': 'Избрани',
  'Your Information': 'Моята информация',
  'Download Your Information': 'Свалете вашата информация',
  'DownloadYourInformationDescription': "Можете да изтеглите копие от информацията си в MedXchange по всяко време. Можете да изтеглите цялата информация наведнъж в JSON формат, който може да позволи на друга услуга да я импортира по-лесно. Ако искате да видите информацията си, без да я изтеглите, можете да осъществите достъп до информацията си по всяко време.",
  'Download': 'Свалете',
  'Delete Account': 'Изтрий акаунт',
  'Permanently Delete Account': 'Изтрийте Вашият акаунт',
  'DeleteAccountPermanentlyDescription': "Може да изтриете акаунта си в MedXchange по всяко време. След като процесът на изтриване започне, няма да можете да активирате отново профила си или да изтеглите съдържанието или информацията, която сте добавили.",
  'Are you sure that you want to delete your Account permanently?': 'Сигурни ли сте, че искате да изтриете Вашият акаунт завинаги?',
  'Confirm Dialog': 'Диалог за потвърждение',
  'Yes': 'Да',
  'No': 'Не',
  '5000': 'Избраното заболяване вече е добавено.',
  '5001': 'Избраното лекарството вече е добавено.',
  'Disease History': 'Хронология на заболяването',
  'Medicine History': 'Прием на лекарство',
  '5002': 'Несъществуващо заболяване.',
  '5003': 'Несъществуващо лекарство.',
  'My Family': 'Моето семейство',
  'Cookies Policy': 'Политика за бисквитките',
  'Personal Data Policy': 'Политика за личните данни',
  'Check': 'Провери',
  'Result': 'Резултата',
  'Start with': 'Започващи с',
  'Selected medicine already exist in list.': 'Избраното лекарство вече е добавено.',
  'Male': 'Мъж',
  'Female': 'Жена',
  'ZeroNeagtive': '0-',
  'ZeroPositive': '0+',
  'ANegative': 'A-',
  'APositive': 'А+',
  'BNegative': 'B-',
  'BPositive': 'B+',
  'ABNegative': 'AB-',
  'ABPositive': 'AB+',
  'Gender': 'Пол',
  'Blood Type': 'Кръвна група',
  'Personal Data': 'Лични данни',
  'Account': 'Акаунт',
  'Height (cm)': 'Височина (см)',
  'Weight (kg)': 'Тегло (кг)',
  'Birthdate': 'Дата на раждане',
  'Other parameters': 'Други параметри',
  'Add medicine to check interactions.': 'Добави лекарства, за да провериш взаимодействията им.',
  'Other parameters interactions': 'Взаимодействия с други параметри',
  'There is no drug interactions.': 'Няма взаимодействия с лекарства.',
  'There is no diseases interactions.': 'Няма взаимодействия със заболявания.',
  'There is no other interactions.': 'Няма ваимодействия с други параметри.',
  'EnterDiseaseName': 'Въведете име на болеста',
  'EnterDiseaseCode': 'Въведете код на болеста',
  'StartEndDate': 'Начална - крайна дата',
  'DoseTake': 'Доза - приемане',
  'ToMyFriends': 'Всички',
  'Son': 'Син',
  'Daughter': 'Дъщеря',
  'Father': 'Баща',
  'Mother': 'Майка',
  'Sister': 'Сестра',
  'Brother': 'Брат',
  'Husband': 'Съпруг',
  'Wife': 'Съпруга',
  'Other': 'Друг',
  'RelationType': 'Роднинска връзка',
  'AddindFamily': 'Добавяне на роднина',
  'Description': 'Описание',
  'Recurrency Type': 'Тип повтаряемост',
  'Notification Type': 'Тип на известието',
  'Notifications': 'Известия',
  'Date': 'Дата',
  'Time': 'Време',
  'Notes': 'Бележки',
  'Active': 'Активен',
  'Frequency': 'Честота',
  'Occurs once at': 'Случва се веднъж в',
  'Occurs every hour(s)': 'Случва се на всеки час(а)',
  'Starting at': 'Започва в',
  'Ending at': 'Приключва в',
  'Recurs every': 'На всеки',
  'Recurs every(f)': 'На всяка',
  'day(s)': 'ден(а)',
  'week(s)': 'седмица(и)',
  'month(s)': 'месец(и)',
  'OneTime': 'Единична',
  'Recurring': 'Повтаряща се',
  'Daily': 'Дневна',
  'Weekly': 'Седмична',
  'Monthly': 'Месечна',
  'Occurs on': 'Случва се',
  'at': 'в',
  'Occurs every': 'Случва се всеки',
  'Schedule will be used between': 'Графикът ще бъде използван между',
  'and': 'и',
  'Schedule will be used starting on': 'Графикът ще бъде използван започвайки от',
  'day': 'ден',
  'week': 'седмица',
  'month': 'месец',
  'every': 'всеки',
  'hour(s) between': 'час(а) между',
  'EditingFamily': 'Редакция на роднина',
  'UserInfo': 'Информация за потребител',
  'InfoForUser': 'Информация за ',
  'Information': 'Информация',
  'DriveMachine': 'Шофиране и работа с машини',
  'When driving': 'При шофиране',
  'When using machine': 'При работа с машини',
  'My Condition': 'Моето състояние',
  'My Profile': 'Моят профил',
  'Settings': 'Настройки',
  'BloodPressure': 'Кръвно налягане',
  'HeartRate': 'Пулс',
  'Height': 'Височина',
  'Weight': 'Тегло',
  'On': 'На',
  'Every': 'Всеки',
  'Notification': 'Известие',
  'Once at': 'Веднъж в',
  'Every hour(s)': 'На всеки час(а)',
  'AddCondition': 'Добавяне на състояние',
  'EditCondition': 'Редакция на състояние',
  'Condition': 'Състояние',
  'Value': 'Стойност',
  'ConditionInList': 'Следното/е състояние/я вече съществуват във вашия списък',
  'ConditionConfirm': 'Сигурни ли сте, че искате да изтриете характеристиката и всички нейни стойности',
  'See': 'Виж',
  'Unit': 'Мерна единица',
  'EnterHeight': 'Въведете височина (170)',
  'EnterWeight': 'Въведете тегло (70)',
  'EnterBloodPressure': 'Въведете кръвно налягане (140/80)',
  'EnterHeartRate': 'Въведете пулс (60)',
  'EnterDesc': 'Описание (главоболие, болки в корема)',
  'EnterHemoglobin': 'Въведете хемоглобин (140)',
  'for': 'за',
  'medicine': 'лекарство',
  'prescription': 'рецепта',
  'ViewCond': 'Преглед на състояние',
  'Language': 'Език',
  'AddNewCondition': 'Добавяне на ново състояние',
  'Filters': 'Филтри',
  'NotAllEntered': 'Моля въведете всички стойности',
  'MedicinesForPrescription': "Лекарства към рецепта",
  'DiseasesForPrescription': "Заболявания към рецепта",
  'Legend': 'Легенда',
  'PushNotification': 'Известие',
  'Receive Push Notifications': 'Получаване на известия',
  'User Settings': 'Потребителски настройки',
  'You have to be logged in to activate Notifications.': 'Трябва да се логнете, за да управлявате известията.',
  'Bulgarian': 'Български',
  'English': 'Английски',
  'You have successfully subscribed for Notifications.': 'Вие успешно се записахте за известия.',
  'You have successfully unsubscribed from Notifications.': 'Вие успешно се отписахте от известия.',
  'Failed to unsubscribe from Push Notifications:': 'Неуспешно отписване от известия:',
  'Failed to subscribe for Push Notifications:': 'Неуспешно записване за известия:',
  'Sunday': 'Неделя',
  'Monday': 'Понеделник',
  'Tuesday': 'Вторник',
  'Wednesday': 'Сряда',
  'Thursday': 'Четвъртък',
  'Friday': 'Петък',
  'Saturday': 'Събота',
  'sunday': 'неделя',
  'monday': 'понеделник',
  'tuesday': 'вторник',
  'wednesday': 'сряда',
  'thursday': 'четвъртък',
  'friday': 'петък',
  'saturday': 'събота',
  'on': 'на',
  'Every(f)': 'Всяка',
  'Hourly': 'Часова',
  'Alarm Time': 'Час на аларма',
  'hour(s)': 'час(а)',
  'hour': 'час',
  'between': 'между',
  'starting on': 'започвайки от',
  'from': 'от',
  "ActiveА": "Активна",
  "NotActive": "Неактивна",
  'Deleted Successfully': "Изтриването беше успешно",
  'Data Saved Successfully': "Данните бяха записани успешно",
  'Medicines of': "Лекарства на",
  'Diseases of': 'Заболявания на',
  'Menu': 'Меню',
  'Of': 'на',
  'Confirm Message': 'Сигурни ли сте, че искате да изтриете',
  'This record': 'този запис',
  'And medicines diseases notifications': 'и лекарствата, заболяванията и алармите към нея',
  'Are you sure you want to logout': 'Сигурни ли сте, че искате да излезете?',
  'No disease selected': 'Няма избрано заболяване',
  'No medicine selected': 'Няма избрано лекарство',
  '5004': 'Несъществуваща рецепта',
  '5005': 'Несъществуваща аларма',
  '5006': 'Невалидна дата на аларма',
  '5007': 'Несъществуващ график на аларма',
  '6000': 'Несъществуваща активна съставка',
  '6001': 'Невалидни странични ефекти',
  '6002': 'Невалидни дозировки',
  '6003': 'Несъществуваща болест',
  '6004': 'Несъществуващи храна или алкохол',
  '6005': 'Несъществуваща неактвина съставка',
  '6006': 'Несъществуващ производител',
  '6007': 'Невалидни бременност или кърмене',
  '6008': 'Невалидни шофьор или машина',
  '6009': 'Невалидни данни за сигурност',
  'Do you want to activate notification on this device': 'Искате ли да активирате известията на това устройство',
  'Alarm time cannot be empty': 'Часът на алармата не може да бъде празен',
  'Date cannot be empty': 'Датата не може да бъде празна',
  'Alarm date and/or time': 'Датата и/или часът',
  'are lesser than current time': 'са по-малки от настоящата дата',
  'Alarm will never execute': 'Алармата няма как да се изпълни',
  'Please choose frequency': 'Моля изберете  "Тип повтаряемост"',
  'Please choose counter': 'Моля изберете "На всеки ден(а)"',
  'Start date cannot be empty': 'Началната дата не може да бъде празна',
  'Start date is greater than end date': 'Началната дата е по-голяма от крайната',
  'End date is lesser than today': 'Крайната дата е по-малка от настоящата',
  '5008': 'Датата на алармата е изтекла',
  'Are you sure that you want to delete this record': 'Сигурни ли сте, че искате да изтриете този запис?',
  ' Medicine will be removed from prescription ': ' Лекарството ще бъде изтрито от рецепта ',
  ' Disease will be removed from prescription ': ' Болестта ще бъде изтрита от рецепта ',
  'Please select disease': 'Моля изберете заболяване',
  'Please select medicine': 'Моля изберете лекарство',
  '6010': 'Несъществуващ файл',
  '6011': 'Несъществуващи данни за специалисти',
  '6012': 'Несъществуващи данни за бременност и кърмене',
  '6013': 'Несъществуващи данни за шофьор и машина',
  '6014': 'Несъществуващи данни за странични ефекти',
  '6015': 'Несъществуващи данни за дозировка',
  '6016': 'Несъществуващи данни за взаимодействие',
  'Please enter a valid e-mail address.': 'Моля въведете валидна електронна поща.',
  'Please enter personal name.': 'Моля въвдете вашето име.',
  '6 characters or more, at least 1 alphabetical and 1 numeric.': 'Минимум 6 символа, с поне една буква и една цифра.',
  'Please enter password again.': 'Моля въведете паролата отново.',
  'Password must be at least 6 characters and contain at least 1 alphabetical and 1 numeric character': 'Паролата трябва да е минимум 6 символа, с поне една буква и една цифра',
  'You have to take medicines at': 'Имате да приемате лекарства в',
  'oclock on date': 'часа на дата',
  '5009': 'Несъществуващ запис към лекарство',
  '5010': 'Несъществуващ запис към болест',
  'No records found': 'Няма намерени записи.',
  'total records.': 'резултат(а) общо.',
  'current medicine history.': 'прием(а) на лекарство към настоящия момент.',
  'current disease count.': 'заболявания към настоящия момент.',
  'have to take his/hers medicines at': 'има да приема лекарства в',
  'current prescriptions.': 'рецепта(и) към настоящия момент.',
  'You don\'t have new notifications': 'Нямате нови известия.',
  'You don\'t have old notifications': 'Нямате стари известия',
  'See All': 'Виж всички',
  'Search': "Търсене",
  'Check medicine interactions': 'Провери взаимодействията на лекарства',
  'List of all Diseases': 'Списък на всички заболявания',
  'Find nearest Pharmacy': 'Намери най-близката аптека',
  'Pharmacies': 'Аптеки',
  'Choose characteristic': 'Изберете характеристика',
  'Name of characteristic': 'Име на характеристика',
  'New characteristic': 'Нова характеристика',
  'DateTimeFormat': "dd.MM.yyyy г. HH:mm ч.",
  'DateFormat': 'dd.MM.yyyy г.',
  'SearchDiseaseInDatabase': 'Търсене по име на заболяване',
  'Characteristic already exist': 'Вече има характеристика с такова име',
  'Your characteristics': 'Вашите характеристики',
  'Characteristic is used': 'Тази характеристика се използва в предишно/и състояние/я и не може да бъде изтрита',
  'Test is used': 'Това изследване се използва в предишен/и резултат/и и не може да бъде изтрито',
  'BeforeEating': 'Преди хранене',
  'WhileEating': 'По време на хранене',
  'AfterEating': 'След хранене',
  'Choose acceptance': 'Лекарството е прието',
  'Specification of intake': 'Прием на лекарство',
  'No Intake': 'Няма записан прием',
  'Mark all as seen': 'Маркирай всички като видени',
  'SendNotification': 'Изпрати известие и на',
  'IfItsNotTaken': 'Ако не е прието след',
  'Five': '5 минути',
  'Ten': '10 минути',
  'Fifteen': '15 минути',
  'Twenty': '20 минути',
  'Thirty': '30 минути',
  'Sixty': '1 час',
  'UserCreated': 'Създаване на нов потребител',
  'Caretaker': 'Избор на асистент',
  'SearchUserInDatabase': 'Търсене по имейл',
  'EnterUserName': 'Име или имейл',
  'AlreadyExist': 'Потребителят вече го има във вашият списък',
  'You have successfully accept invitation': 'Вие успешно приехте поканата за асистиране',
  'Confirm': 'Потвърждение',
  'taken at': 'приетo на',
  'Waiting': 'Очаква се потвърждение',
  'Approved': 'Асистент',
  'EnterAddressOrCity': 'Адрес или град',
  'DisposalPlaces': 'Места за събиране на медикаменти',
  'Find nearest Disposal place': 'Намери най-близкото място',
  'Your location': 'Вашето местоположение',
  'Not allowed food and drinks': 'Непозволени храни и напитки',
  'Information about': 'Информация за',
  'ATC code': 'ATC код',
  'Мolecular Formula': 'Молекулна формула',
  'starts with': 'започващи с',
  'contain text': 'съдържащи текста',
  'All medicines': 'Всички лекарства',
  'contain': 'съдържащи',
  'Recommended food and drinks': 'Препоръчителни храни и напитки',
  'Treatment recommendations': 'Препоръки за лечение',
  'Course of treatment': 'Курс на лечение',
  'Start date course of treatment': 'Начална дата на курса на лечение',
  'End date course of treatment': 'Крайна дата на курса на лечение',
  'Allergies': 'Алергии',
  'Porduct Number': 'Номер на продукта',
  'Filtering': 'Филтрирай',
  'Authorised': 'Авторизирано',
  'Withdrawn': 'Изтеглено',
  'Refused': 'Отказано',
  'Pending': 'Изчакващо',
  'Suspended': 'Преустановено',
  'From': 'От',
  'To': 'До',
  'Prescription From Doctor': 'Рецепта от доктор',
  'This medicine is attached to prescription': 'Това лекарство е закачено към рецепта от доктор',
  'This disease is attached to prescription': 'Това заболяване е закачено към рецепта от доктор',
  'Temperature': 'Температура',
  'BloodSugar': 'Кръвна захар',
  'EnterTemperature': 'Въведете температура (36.6)',
  'EnterBloodSugar': 'Въведете кръвна захар (4.8)',
  'PersonalConditionConfirm': 'Сигурни ли сте, че искате да изтриете избраната лична характеристика?',
  'Characteristic': 'Характеристика',
  'Characteristics': 'Характеристики',
  'All conditions': 'Всички състояния',
  'DataSource': 'Източник на информация',
  'EMA': 'Европейска агенция по лекарства',
  'BDA': 'Изпълнителната агенция по лекарства',
  'New': 'Нови',
  'Old': 'Стари',
  'Add Characteristic': 'Въведете стойности.',
  'New Characteristic': 'Нова характеристика',
  'Chatbot': 'Чатбот',
  'Doctors prescriptions': 'Лекарски предписания',
  'Doctors prescription': 'Лекарско предписание',
  'Diet': 'Хранителен режим',
  'Life mode': 'Жизнен режим',
  'Hemoglobin': 'Хемоглобин',
  'Laboratory result': 'Резултати от изследвания',
  'Add Laboratory result': 'Добавете резултати от изследване',
  'Edit laboratory Result': 'Редактиране на резултати от изследване',
  'Add Lab result': 'Добавете изследвания',
  'New laboratory test': 'Ново изследване',
  'Choose test': 'Изберете изследване',
  'LaboratoryResultConfirm': 'Сигурни ли сте, че искате да изтриете избрания резултат от изследвания за ',
  'PersonalTestConfirm': 'Сигурни ли сте, че искате да изтриете избраното лично изследване?',
  'Files': 'Файлове',
  'Add files': 'Добавете файлове',
  'FileRemove': 'Сигурни ли сте, че искате да премахнете избрания файл?',
  'Allowed file types are': 'Позволените разширения са',
  'File size is greater than': 'Файлът е с размер по голям от разрешения',
  'Min': 'Минимална стойност',
  'Max': 'Максимална стойност',
  'laboratoryResultInList': 'Изследването вече е в листа',
  'AgeAbb': 'год.',
  'Over': 'над',
  'Under': 'под',
  'Age': 'Възраст',
  'Reference values': 'Референтни стойности',
  'All Laboratory Results': 'Всички резултати от изследвания',
  'Yours reference values': 'Вашите референтни стойности',
  'Allowed formats': 'Позволени формати',
  'Max total file size': 'Макс. общ размер на файловете',
  'TotalCholesterol': 'Общ холестерол',
  'HighDensityLipoproteinCholesterol': 'HDL холестерол',
  'LowDensityLipoproteinCholesterol': 'LDL холестерол',
  'Triglycerides': 'Триглицериди',
  'EnterTotalCholesterol': 'Въведете общ холестерол(3.2)',
  'EnterHDL': 'Въведете HDL-холестерол(2.1)',
  'EnterLDL': 'Въведете LDL-холестерол(2.5)',
  'EnterTriglycerides': 'Въведете триглицериди(4.3)',
  'LabTest': 'Изследване',
  'Enter valid value': 'Въведете валидни стойности',
  'Scan': 'Сканирай',
  'The connection was interrupted': 'Връзката беше прекъсната',
  'Connect with a device': 'Връзка с Bluetooth (LE) устройства',
  'Current value': 'Текуща стойност',
  'No current value': 'Сканирайте за налични устройства. От списъка с налични устройства изберете желаното и се сдвоете с него (Pair)',
  'BloodPresureValid': 'Уверете се че стойноста е правилно въведена (140/80)',
  'BloodPresureExample': 'Пример: 140/80',
  'BottomNumber': 'Долна граница',
  'TopNumber': 'Горна граница',
  'AddValue': 'Добавете стойност',
  'ConditionTypeConfirm': 'Сигурни ли сте, че искате да изтриете избраният запис?',
  '11003': 'Несъществуващи данни за лабораторен резултат',
  'Enter name or select alpha index': 'Въведете име или изберете буква',
  'TotalResults': 'резултата общо',
  'ReceivingData': 'Получаване на данни...',
  'ReceivedData': 'Получени данни',
  'BottomNumberBigger': 'Долната граница не може да бъде с по-голяма стойност от горната граница',
  'OneDay': '1 ден',
  'OneWeek': '1 седмица',
  'OneMonth': '1 месец',
  'ThreeMonths': '3 месеца',
  'SixMonths': '6 месеца',
  'OneYear': '1 година',
  'Advanced': 'Разширено',
  'Period': 'Период',
  'All Results': 'Всички резултата',
  'Snooze': 'Отложи',
  'min.': 'мин.',
  'snoozed for': 'отложено за',
  'Take': 'Прием',
  'Minutes': 'минути',
  'InCaseThat': 'в случай, че лекарството не е прието след',
  'SendNotificationsTo': 'Изпращане на известие и на',
  'NormInfoPopMessage': 'Изборът на норма се определя от личните ви данни',
  'User Functionalities': 'Потребителски функционалности',
  'Pregnancy and Breastfeeding': 'Бременност, кърмене и фертилитет',
  'DrivingAndUsingMachines': 'Шофиране и работа с машини',
  'EPAR': 'Кратка характеристика на продукта и Листовка за пациента',
  'All diseases': 'Всички заболявания',
  'Enter birht date': 'Изберете рожденна дата',
  'Locations': 'Локации',
  '4007': 'Потребителят не е аутентикиран',
  'current doctors prescriptions.': 'предписание(я) към настоящия момент.',
  'doctor': 'доктор',
  'Doctors prescription from doctor': 'Лекарско предписание от доктор',
}


export default bg;